import { WorkspaceSettingsRoute } from '@pwa/components/dashboard/workspace-settings-page';
import { createFileRoute } from '@tanstack/react-router';

function WorkspaceSettingsRouteWrapper() {
	const { orgId, wsId } = Route.useParams();
	return <WorkspaceSettingsRoute workspaceId={wsId} orgId={orgId} />;
}

export const Route = createFileRoute('/_dashboard/org/$orgId/ws/$wsId/settings')({
	component: WorkspaceSettingsRouteWrapper,
	validateSearch: (_search: Record<string, unknown>) => ({}),
});
